// общий сервис для авторизации и объединения разных сторов
import {
  clearUserToken,
  getAccessToken,
  getSubId,
} from '@devhacker/shared/features/auth/utils/token';
import { useUserService } from '~/features/user/service';
import { logout as logoutApi } from '@devhacker/shared/features/auth/api';
import { useUserStore } from '~/features/user/store';
import { useNotificationStore } from '~/features/notification/store';
import { useNotificationService } from '~/features/notification/service';
import { IS_PRODUCTION } from '~/constants';

export function useAuthService() {
  const { $logger } = useNuxtApp();
  const userStore = useUserStore();
  const userService = useUserService();
  const notificationStore = useNotificationStore();
  const notificationService = useNotificationService();
  const log = $logger.withScope('🔐 auth-service');

  async function login(accessToken = getAccessToken()) {
    log('login');
    if (!accessToken) return;

    const userSubId = getSubId(accessToken);

    if (!userSubId) throw new Error('Failed to parse access token');

    await userService.fetchAndUpdateUser(userSubId);

    // временно отключено на проде до полной готовности
    if (!IS_PRODUCTION) notificationService.connectPrivateChannel();
    if (!IS_PRODUCTION) await notificationStore.fetchUnviewedNotificationsCount();

    // Delayed action
    userStore.afterLoginAction?.();
  }

  function clearSessionLocally() {
    clearUserToken();
    userService.clearUser();
    // временно отключено на проде до полной готовности
    if (!IS_PRODUCTION) notificationService.leavePrivateChannel();
  }

  async function logout() {
    const promise = logoutApi();
    log('logout');
    clearSessionLocally();
    return promise;
  }

  return { login, logout, clearSessionLocally };
}
